module.exports = __webpack_public_path__ + "static/media/search-9.44fdd47e.png";